export default __webpack_public_path__ + "static/media/morocco_icon.4b1a717b.png";